import NotesIcon from "@assets/icons/notes"
import formatDateFromISOString from "src/utils/formatDate"

const CommentHistory = ({ patientData }) => {
  return (
    <div className="py-10 px-8 rounded-2xl bg-[--primary-blue-light] flex flex-col gap-4 max-h-[22.5rem] overflow-y-auto theme-scrollbar">
      <div className="gap-2 flex items-center">
        <NotesIcon stroke="var(--primary-blue)" />
        <div className="text-xs text-[--text-light-gray] font-bold tracking-widest">
          NOTE AND COMMENT HISTORY
        </div>
      </div>

      {patientData?.commentHistory?.map((commentDetails, index) => (
        <div className="flex flex-col gap-2" key={index}>
          <div className="text-sm font-bold text-[--quaternary-black]">
            {formatDateFromISOString(commentDetails.created_at).date}
          </div>
          <div className="p-4 rounded-2xl bg-[--pure-white] grow overflow-y-auto theme-scrollbar">
            {commentDetails.comment}
          </div>
        </div>
      ))}
    </div>
  )
}

export default CommentHistory
